// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductSlider_container__UobQm","header":"ProductSlider_header__1Hlf1","slider":"ProductSlider_slider__urxsS"};